pnx-widget-semantics-filters {
	border-radius: 15px !important;;
	width: 120px !important;;
	max-width: 30vw !important;
	background: white !important;
	background-color: white !important;
	font-family: var(--font-family);
	font-size: 1.0em;
	padding: 3px 0 3px 8px;
}

